/*
Copyright (c) 2012-2026 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/

// URL Query Parameter Keys
export const URL_PARAMS = {
  PAGE: "page",
  PAGE_SIZE: "pageSize",
  STATUS: "status",
  KEYWORD: "keyword",
} as const

// Pagination Constants
export const PAGINATION = {
  DEFAULT_PAGE: 1,
  DEFAULT_PAGE_SIZE: 10,
  PAGE_SIZE_OPTIONS: ["10", "20", "50"] as string[],
  DEFAULT_LIMIT_VARIANT_ITEMS: 100,
}

// Search Constants
export const SEARCH = {
  MIN_KEYWORD_LENGTH: 2, // Minimum characters to trigger search (0 or 2+)
} as const

// Filter Values
export const FILTER_VALUES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const

// Untranslated Strings - Products List
// TODO: Replace with i18n translations in future
export const PRODUCTS_LIST_STRINGS = {
  // Header
  products: "Products",
  createNewItem: "Create New Item",
  bulkFunctions: "Bulk Functions",
  addItemsInBulk: "Add Items in bulk",

  // Search
  searchPlaceholder: "Search by item name",

  // Table Columns
  productInfo: "Product Info",
  price: "Price",
  stock: "Stock",
  active: "Active",
  action: "Action",
  noProductFound: "No products found",
  noItemsFound: "No items found",
  status: "Status",

  // Stock Status
  total: "Total",
  available: "Available",
  soldOut: "Sold out",

  // Actions
  edit: "Edit",

  // Filters
  filterActive: "Active",
  filterInactive: "Inactive",

  // Product table
  pricePlaceholder: "-",
} as const

// Product status values (API contract)
export const PRODUCT_STATUS = {
  ACTIVE: "ACTIVE",
} as const

// Products table row type discriminators (discriminated union)
export const ROW_TYPE = {
  PRODUCT: "product",
  ITEM: "item",
  LOADING: "loading",
} as const

// Products table row key prefixes and column keys
export const PRODUCT_TABLE_KEYS = {
  ROW_KEY_PROP: "rowKey",
  ROW_KEY_PREFIX_PRODUCT: "product-",
  ROW_KEY_PREFIX_ITEM: "item-",
  ROW_KEY_PREFIX_LOADING: "loading-",
  COLUMN_PRODUCT_INFO: "productInfo",
  COLUMN_PRICE: "price",
  COLUMN_ACTIVE: "active",
  COLUMN_ACTION: "action",
} as const

export const DEFAULT_DEBOUNCE_WAIT_TIME = 500

// Storefront Collection List Constants
export const STOREFRONT_COLLECTION_LIST_STRINGS = {
  storefrontCollections: "Storefront Collections",
  create: "Create",
} as const

// Untranslated Strings - Video Upload
// TODO: Replace with i18n translations in future
export const VIDEO_UPLOAD_STRINGS = {
  loadingUploading: "Uploading...",
  loadingProcessing: "Processing...",
  loadingPreparing: "Preparing...",
  addVideo: "Add video",
  videoThumbnailAlt: "Video thumbnail",
  guidelineSize: (maxMb: number) => `Size: Max ${maxMb}MB`,
  guidelineDuration: (minSec: number, maxSec: number) =>
    `Duration: ${minSec}-${maxSec}s`,
  guidelineFormat: (extensions: string) => `Format: ${extensions}`,
} as const
